import {Drawer, InputGroup} from "@blueprintjs/core";
import {observer} from "mobx-react";
import React from "react";

import {ColumnDef, Td, Tr} from "../../atoms/tables/table";
import {TableLayout} from "../../organisms/table-layout/table-layout";

export type SelectedOptionsValue = {
    imageUrl: string;
    altText: string;
    sourceTitle: string;
    sourceUrl: string;
};

export type OptionField =
    | {key: "label"; label: string; renderAs: "text"}
    | {
          key: keyof SelectedOptionsValue;
          label: string;
          placeholder: string;
          ariaLabel?: string;
          renderAs: "input";
      };

export type OptionsDrawerProps = {
    isOpen: boolean;
    onClose: () => void;
    optionFields: OptionField[];
    selectedRowLabel: string;
    selectedOptions: Record<string, SelectedOptionsValue>;
    selectedId: string | null;
    setOption: (field: keyof SelectedOptionsValue, value: string) => void;
    columns?: ColumnDef[];
};

export const TemplateOptionsDrawer: React.FC<OptionsDrawerProps> = observer(
    ({
        isOpen,
        onClose,
        optionFields,
        selectedRowLabel,
        selectedOptions,
        selectedId,
        setOption,
        columns = [
            {label: "項目のオプション(画像)", width: 150, required: false},
            {label: "", width: 0, required: false},
        ],
    }) => (
        <Drawer isOpen={isOpen} position="bottom" onClose={onClose}>
            <TableLayout isFill areaLabel="項目のオプション" columns={columns}>
                {optionFields.map((field) => {
                    if (field.renderAs === "text") {
                        return (
                            <Tr key="label">
                                <Td>{field.label}</Td>
                                <Td>{selectedRowLabel}</Td>
                            </Tr>
                        );
                    }
                    const opts = (selectedId && selectedOptions[selectedId]) || {
                        imageUrl: "",
                        altText: "",
                        sourceTitle: "",
                        sourceUrl: "",
                    };
                    const value = opts[field.key];
                    return (
                        <Tr key={field.key}>
                            <Td>{field.label}</Td>
                            <Td>
                                <InputGroup
                                    {...(field.ariaLabel ? {"aria-label": field.ariaLabel} : {})}
                                    placeholder={field.placeholder}
                                    value={value}
                                    onChange={(e) => setOption(field.key, e.currentTarget.value)}
                                />
                            </Td>
                        </Tr>
                    );
                })}
            </TableLayout>
        </Drawer>
    ),
);
